import { Users, Building2, Crown } from 'lucide-react';
import { AGENTS, DEPARTMENTS } from '../../utils/agents';
import { StatCard } from '../common/StatCard';
import { OrgTree } from './OrgTree';
import { DepartmentGrid } from './DepartmentGrid';

const cSuiteCount = AGENTS.filter((a) => a.isCSuite).length;
const totalAgents = AGENTS.length;
const totalDepts = DEPARTMENTS.length;

export default function OrganizationPage() {
  return (
    <div className="space-y-4 md:space-y-6">
      {/* Stats Bar */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        <StatCard
          label="Total Agents"
          value={totalAgents}
          icon={<Users />}
        />
        <StatCard
          label="Departments"
          value={totalDepts}
          icon={<Building2 />}
        />
        <StatCard
          label="C-Suite Executives"
          value={cSuiteCount}
          icon={<Crown />}
        />
      </div>

      {/* Org Tree */}
      <div className="bg-bg-secondary border border-border-subtle rounded-lg p-4">
        <h2 className="text-lg font-semibold text-text-primary mb-4">Organization Hierarchy</h2>
        <div className="max-h-[600px] overflow-y-auto overflow-x-auto">
          <OrgTree />
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-border-subtle" />

      {/* Department Grid */}
      <DepartmentGrid />
    </div>
  );
}
